import React from 'react';
import { Link } from 'react-router-dom';

const linkHref = (category) => `/resource-library/${category.wp_id}`

const LinkToCategory = ({ category, text = null }) => (
  <Link key={category.wp_id} to={linkHref(category)}>
    {text || category.name}
  </Link>
)

export default LinkToCategory



// WEBPACK FOOTER //
// ./src/components/ResourceLibrary/LinkToCategory.js